// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__DMPfP","rootSmall":"AddTileButton_rootSmall__Nm0cR"};